'use strict';

const _ = require('lodash');

const Enum = require('./enum');

/**
 * @enum {String}
 * @readonly
 */
const TransferTypes = {
  COPY: 'copy',
  MOVE: 'move',
  RECEIVE: 'receive',
};

/**
 * @enum {String}
 * @readonly
 */
const TransferStates = {
  INIT: 'init',
  SCAN: 'scan',
  COPY: 'copy',
  DELETE: 'delete',
  DONE: 'done',
};

/**
 * @enum {String}
 * @readonly
 */
const TransferStatuses = {
  REQUESTED: 'requested',
  IN_PROGRESS: 'inprogress',
  DONE: 'done',
  ERROR: 'error',
};

/**
 * @enum {String}
 * @readonly
 */
const TransferDocStates = {
  PENDING: 'pending',
  COPIED: 'copied',
  DELETED: 'deleted',
  RECEIVED: 'received',
  ERROR: 'error',
};

module.exports = {
  TransferTypes: Object.create(
    Enum,
    _.transform(TransferTypes, (result, value, key) => (result[key] = { value, enumerable: true }))
  ),
  TransferStates: Object.create(
    Enum,
    _.transform(TransferStates, (result, value, key) => (result[key] = { value, enumerable: true }))
  ),
  TransferStatuses: Object.create(
    Enum,
    _.transform(TransferStatuses, (result, value, key) => (result[key] = { value, enumerable: true }))
  ),
  TransferDocStates: Object.create(
    Enum,
    _.transform(TransferDocStates, (result, value, key) => (result[key] = { value, enumerable: true }))
  ),
};
